var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulbFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 976q-34 0-57.5-23.5T399 895h162q0 34-23.5 57.5T480 976ZM318 833v-60h324v60H318Zm5-121q-66-43-104.5-107.5T180 459q0-122 89-211t211-89q122 0 211 89t89 211q0 81-38 145.5T637 712H323Zm22-60h271q48-32 76-83t28-110q0-99-70.5-169.5T480 219q-99 0-169.5 70.5T240 459q0 59 28 110t77 83Zm135 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbFill);
export default __webpack_public_path__ + "static/media/lightbulb-fill.3b34980ff75b7bf1a52f47953f6fcda9.svg";
export { ForwardRef as ReactComponent };